module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-portal-4.bc8903e7.svg";